import React from 'react';
import ExperienceEndingStructured from './experience-ending-structured';
import MediaTextBlock from '../media-text-block';
import SafeHtml from '../../../atoms/safe-html';

const ExperienceInfo = ({
  dateText,
  introTitleText,
  infoIntroText,
  blocks = [],
  experienceKey = '',
  structuredEnding,
  endingText,
  endingColumns = [],
  imagePosition
}) => {
  const infoClassName = ['info', 'experience-info', experienceKey ? `experience-info--${experienceKey}` : '']
    .filter(Boolean)
    .join(' ');
  const hasEndingColumns = Array.isArray(endingColumns) && endingColumns.length > 0;

  return (
    <section className={infoClassName}>
      <div className="inner experience-info__inner">
        <div className="date experience-info__date">{dateText}</div>
        <div className="intro experience-info__intro">
          {introTitleText && <h2 className="experience-info__intro-title">{introTitleText}</h2>}
          <p className="experience-info__intro-text">{infoIntroText}</p>
        </div>

        {blocks.map((block, index) => {
          const blockNumber = index + 1;
          const blockClassName = [
            'experience-info__block',
            `experience-info__block--${blockNumber}`,
          ].join(' ');

          return (
            <MediaTextBlock
              key={`experience-block-${index}`}
              className={blockClassName}
              image={block.image}
              images={block.images}
              imageLayout={block.imageLayout}
              imagePosition={(imagePosition?.[index]) ?? (index % 2 === 1 ? 'end' : 'start')}
              textHtml={block.text}
            />
          );
        })}

        {structuredEnding && typeof structuredEnding === 'object' ? (
          <ExperienceEndingStructured content={structuredEnding} />
        ) : hasEndingColumns ? (
          <div className="experience-ending experience-ending--columns">
            {endingColumns.map((columnText, index) => (
              <SafeHtml
                as="p"
                key={`experience-ending-column-${index + 1}`}
                className={`experience-ending__column experience-ending__column--${index + 1}`}
                html={columnText}
              />
            ))}
          </div>
        ) : (
          endingText && (
            <div className="experience-ending">
              <SafeHtml as="p" html={endingText} />
            </div>
          )
        )}
      </div>
    </section>
  );
};

export default ExperienceInfo;
